import Dexie from "dexie";
import { SearchNode, SearchBase } from "./search-node.class";

export const SCHEMA_VERSION = 2.2; // NOTE: Change this version whenever there was an change to the db tables or fields
export class SearchDatabase extends Dexie {
    nodes!: Dexie.Table<SearchNode, string[]>;
    search!: Dexie.Table<SearchBase, string[]>;
    metadata!: Dexie.Table;
    constructor(db_name: string) {
        super(db_name);
        this.version(SCHEMA_VERSION).stores({
            nodes: "[collection_id+id], id, collection_id, parent_id, *name_tokens, name, type, last_modification_date",
            search: "[collection_id+id], collection_id, id, sequence, cursor_sequence, cursor_sub_sequence, has_more",
            metadata: "&key"
        });
        this.nodes.mapToClass(SearchNode);
    }
}
